module.exports = __webpack_public_path__ + "static/media/Secret-message-min.71e230ac.png";